import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    .pagination {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    ul {
      list-style: none;
      padding: 0;
    }

    ul.pagination li {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 25x;
      /* border: 1px solid ${theme.colors.xxlightGray}; */
      cursor: pointer;
      border: none;
      &.disabled a.page-link {
        color: ${theme.colors.lightGray};
      }
    }

    ul.pagination li a {
      text-decoration: none;
      color: ${theme.colors.black};
      font-size: 20px;
      border: none;
      font-size: 16px;
      font-family: ${theme.font.comfortaa};
      line-height: 1;
    }

    ul.pagination li.active a {
      color: ${theme.colors.white};
    }

    ul.pagination li.active {
      background-color: ${theme.colors.primary};
      border-radius: 8px;
      height: 40px;
    }

    ul.pagination li a:hover,
    ul.pagination li a.active {
      filter: brightness(0.8);
    }

    .page-selection {
      width: 48px;
      height: 30px;
      color: ${theme.colors.black};
    }

    .pagination-wrapper {
      display: flex;
      justify-content: space-between;
      margin-top: 18px;
    }
  `}
`
